<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "PlaneVue",
    components: {},
    props: {
        darker: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        roundedBottom: {
            type: Boolean,
            default: true,
        },
        primary: {
            type: Boolean,
            default: false,
        },
        secondary: {
            type: Boolean,
            default: false,
        },
    },
    emits: [],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <div class="plane flex flex--v flex--valign-c flex--halign-c" :class="{ 'plane--darker': darker, 'plane--rounded': rounded, 'plane--rounded-bottom': roundedBottom, 'plane--primary': primary, 'plane--secondary': secondary }" @click.stop>
        <div v-if="!!$slots.background" class="plane-background">
            <slot name="background"></slot>
        </div>

        <div class="plane-content">
            <slot name="default"></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.plane {
    position: relative;
    width: 100%;
    padding: rem(25);

    background-color: $color-accent-light-a;
    border-radius: rem(5);

    &.plane--darker {
        background-color: $color-accent-light-b;
    }
    &.plane--primary {
        background-color: unset;
        background-image: $primary-gradient;
    }
    &.plane--secondary {
        background-color: unset;
        background-image: $secondary-gradient;
    }

    &.plane--rounded,
    &.plane--rounded .plane-background {
        border-radius: rem(25);
    }
    &:not(.plane--rounded-bottom),
    &:not(.plane--rounded-bottom) .plane-background {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .plane-content {
        position: relative;
        z-index: 1;
        width: 100%;
        min-height: 100%;
        pointer-events: inherit;
    }

    .plane-background {
        position: absolute;
        inset: 0;
        z-index: 0;
        border-radius: rem(5);
        overflow: hidden;
    }
}
</style>
